exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GigyaScreenSetHost-module__gigyaScreenSetHost--z4UJk {\n  margin-top: 5rem; }\n  @media screen and (max-width: 833px) {\n    .GigyaScreenSetHost-module__gigyaScreenSetHost--z4UJk {\n      padding: 0 2rem; } }\n", ""]);

// exports
exports.locals = {
	"gigyaScreenSetHost": "GigyaScreenSetHost-module__gigyaScreenSetHost--z4UJk"
};